export default __webpack_public_path__ + "static/media/image5.a57d3434.jpeg";